import { experience, contact } from '../data/portfolio';
import { Motif } from './Ornaments';
import { Reveal } from './Motion';

export const Experience = () => <section className="experience-section page-inset" data-testid="experience-section" aria-labelledby="experience-heading">
  <Reveal className="center-heading"><span className="eyebrow" data-testid="experience-label">03 / ALONG THE WAY</span><h2 id="experience-heading" data-testid="experience-heading">EXPERIENCE</h2></Reveal>
  <div className="timeline" data-testid="experience-timeline">
    <span className="timeline-cap timeline-cap-top" data-testid="timeline-cap-now">NOW · 2026</span>
    {experience.map((item, i) => <Reveal className={`experience-item ${i % 2 ? 'item-left' : 'item-right'}`} key={item.company} data-testid={`experience-${i}`}>
      <div className="experience-copy">
        <span className="experience-dates eyebrow" data-testid={`experience-dates-${i}`}>{item.dates}</span>
        <h3 data-testid={`experience-company-${i}`}>{item.company}</h3>
        <p className="experience-role" data-testid={`experience-role-${i}`}>{item.role}</p>
        <p className="experience-description" data-testid={`experience-description-${i}`}>{item.description}</p>
      </div>
      <Motif className="experience-motif" variant={i % 2 ? 'red' : 'blue'} />
    </Reveal>)}
    <span className="timeline-cap timeline-cap-bottom" data-testid="timeline-cap-start">WHERE IT STARTED · 2023</span>
  </div>
  <div className="resume-link-row"><a href={contact.resume} target="_blank" rel="noopener noreferrer" className="text-link" data-testid="view-resume">VIEW RESUME <span>↗</span></a><span className="eyebrow" data-testid="resume-note">THE SHORT VERSION, ON PAPER.</span></div>
</section>;